<template>
    <div>
        <DsSpinner v-if="loading" />
        <div v-else>
            <DsInputField
                v-model="daysBeforeExpiration"
                type="number"
                name="number"
                :label="$t('funnel.edit.goal.integration.creditCard.expired.in.x.days')"
                :step="5"
                :min="0"
                :max="90"
            />
        </div>
        <div class="footer">
            <DsFilledButton
                v-if="isCreditCardExpirationTriggerEnabled"
                @click="updateConfig"
            >
                {{ $t('global.save') }}
            </DsFilledButton>

            <DsFilledButton class="cancel-button" @click="closeModal">
                {{ $t('global.cancel') }}
            </DsFilledButton>
        </div>
    </div>
</template>

<script>
import {
    createOrUpdateCreditCardExpiredConfig,
    getCreditCardExpiredConfig,
} from './credit.card.expiration.api';

const MESSAGE_TYPES = {
    SAVE: 'save',
    CLOSE: 'close',
};

export default {
    components: {},
    props: {
        cell: {
            type: Object,
            required: true,
        },
        oracleId: {
            type: String,
            required: true,
        },
        flagsInfo: {
            type: Object,
            default: () => ({}),
        },
    },
    emits: ['internal-receive-message'],

    data() {
        return {
            loading: true,
            daysBeforeExpiration: 30,
            oracleIdValue: this.oracleId,
        };
    },

    computed: {
        isCreditCardExpirationTriggerEnabled() {
            return this.flagsInfo.creditCardExpirationTriggerEnabled;
        },
    },

    async mounted() {
        if (this.oracleId) {
            const data = await getCreditCardExpiredConfig(this.oracleId);

            this.daysBeforeExpiration = data.daysBeforeExpiration;
        }

        this.loading = false;
    },

    methods: {
        closeModal() {
            this.$emit('internal-receive-message', { data: { type: MESSAGE_TYPES.CLOSE } });
        },

        async updateConfig() {
            await createOrUpdateCreditCardExpiredConfig(this.oracleIdValue, this.daysBeforeExpiration);

            this.$emit('internal-receive-message', { data: { type: MESSAGE_TYPES.SAVE, isReady: true } });
        },
    },
};
</script>

<style scoped lang="scss">
.cancel-button {
    margin-left: 20px;
}
.footer {
    display: flex;
    justify-content: flex-end;
}
</style>
